import { useCallback } from "react";
import { useMatch, useNavigate } from "react-router";
import { createSearchParams, useSearchParams } from "react-router-dom";

import { POLICIES_PATH } from "@routing/paths";

/**
 * Hook that returns a function to open policy details page
 * @returns
 */
export function useOpenPolicyDetails() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const match = useMatch(`/${POLICIES_PATH}/*`);

  return useCallback(
    (policyLocator: string) => {
      navigate({
        pathname: `/${POLICIES_PATH}/${policyLocator}`,
        search: !!match
          ? createSearchParams(searchParams).toString()
          : undefined,
      });
    },
    [navigate, searchParams]
  );
}
